(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["abris-delivery-date"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('abris-delivery-date')) {
    const selections = new Map();

    class AbrisDeliveryDate extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.shopify-section');
        this.start = this.querySelector('[data-delivery-start]');
        this.end = this.querySelector('[data-delivery-end]');
        if (!this.scope || !this.start) return;

        const saved = selections.get(this.dataset.key);
        if (saved) {
          this.start.value = saved.start;
          if (this.end) this.end.value = saved.end;
        }

        this.abort = new AbortController();
        const { signal } = this.abort;

        this.addEventListener('input', () => this.update(), { signal });
        this.addEventListener('change', () => this.update(), { signal });

        this.scope.addEventListener(
          'submit',
          (event) => {
            if (event.target !== this.form) return;
            this.update();

            for (const input of [this.start, this.end].filter(Boolean)) {
              if (!input.checkValidity()) {
                event.preventDefault();
                event.stopImmediatePropagation();
                input.reportValidity();
                return;
              }
            }
          },
          { capture: true, signal }
        );

        this.observer = new MutationObserver(() => this.bindForm());
        this.observer.observe(this.scope, { childList: true, subtree: true });
        this.bindForm();
        this.update();
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.formAbort?.abort();
        this.property?.remove();
      }

      bindForm() {
        const form = this.scope.querySelector('product-form-component form[action*="/cart/add"]');
        if (!form || form === this.form) return;

        this.formAbort?.abort();
        this.property?.remove();
        this.form = form;
        this.formAbort = new AbortController();

        if (!form.id) form.id = `DeliveryForm-${this.dataset.key}`;
        for (const input of [this.start, this.end].filter(Boolean)) input.setAttribute('form', form.id);

        this.property = document.createElement('input');
        this.property.type = 'hidden';
        this.property.name = 'properties[Livraison souhaitée]';
        form.append(this.property);

        form.addEventListener(
          'formdata',
          (event) => {
            const value = this.preference();
            if (value) event.formData.set(this.property.name, value);
            else event.formData.delete(this.property.name);
          },
          { signal: this.formAbort.signal }
        );

        this.update();
      }

      update() {
        const today = new Date();
        today.setDate(today.getDate() + (Number(this.dataset.lead) || 0));

        const localDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(
          today.getDate()
        ).padStart(2, '0')}`;

        const iso = /^\d{4}-\d{2}-\d{2}$/;
        const earliest = iso.test(this.dataset.earliest) ? this.dataset.earliest : '';

        this.start.min = earliest > localDate ? earliest : localDate;
        this.start.max = iso.test(this.dataset.latest) ? this.dataset.latest : '';
        this.start.required = this.dataset.required === 'true' || Boolean(this.end?.value);

        if (this.end) {
          this.end.min = this.start.value > this.start.min ? this.start.value : this.start.min;
          this.end.max = this.start.max;
          this.end.required = this.dataset.required === 'true' || Boolean(this.start.value);
        }

        for (const input of [this.start, this.end].filter(Boolean)) {
          input.dataset.hasValue = input.value ? 'true' : 'false';
        }

        selections.set(this.dataset.key, {
          start: this.start.value,
          end: this.end?.value || ''
        });

        const value = this.preference();

        if (this.property) {
          this.property.value = value;
          this.property.disabled = !value;
        }

        this.dispatchEvent(new CustomEvent('abris:delivery-change', { bubbles: true }));
      }

      preference() {
        if (
          !this.start.value ||
          !this.start.checkValidity() ||
          (this.end && (!this.end.value || !this.end.checkValidity()))
        ) {
          return '';
        }

        return this.end ? `${this.start.value} – ${this.end.value}` : this.start.value;
      }
    }

    customElements.define('abris-delivery-date', AbrisDeliveryDate);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["abris-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('abris-delivery-estimate')) {
  class AbrisDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.scope=this.closest('.shopify-section')||document;
      this.fee=this.querySelector('[data-abris-delivery-fee]');
      this.windowText=this.querySelector('[data-abris-delivery-window]');
      this.refreshWindow();
      this.queue=()=>{
        if(this.frame)return;
        this.frame=requestAnimationFrame(()=>{
          this.frame=null;
          this.refreshInstallation();
        });
      };
      this.observer=new MutationObserver(records=>{
        if(records.some(record=>!this.contains(record.target)))this.queue();
      });
      this.observer.observe(this.scope,{
        subtree:true,
        childList:true,
        attributes:true,
        attributeFilter:['checked','aria-checked','class','disabled','hidden']
      });
      this.scope.addEventListener('change',this.queue,true);
      this.scope.addEventListener('input',this.queue,true);
      this.scope.addEventListener('click',this.queue,true);
      this.poll=window.setInterval(()=>{
        if(!this.isConnected)return;
        if(!document.hidden)this.queue();
      },450);
      this.refreshInstallation();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.clearInterval(this.poll);
      if(this.frame)cancelAnimationFrame(this.frame);
      this.scope?.removeEventListener('change',this.queue,true);
      this.scope?.removeEventListener('input',this.queue,true);
      this.scope?.removeEventListener('click',this.queue,true);
    }
    refreshInstallation() {
      let installed=false;
      const selected=this.scope.querySelectorAll('input.tpo-checkbox-button:checked');
      for(const input of selected) {
        const option=input.closest('.tpo_option-container');
        if(input.disabled||option?.hidden||option?.classList.contains('tpo_hidden'))continue;
        if(option&&getComputedStyle(option).display==='none')continue;
        const label=input.closest('label');
        if(!label)continue;
        const title=label.querySelector('.tpo_option_type_label');
        const name=(title?.textContent||label.textContent||'').replace(/\s+/g,' ').trim();
        if(/installation\s*(?:compl[eè]te|cl[eé]\s*en\s*main)|complete\s*installation|turnkey\s*installation/i.test(name)){
          installed=true;
          break;
        }
      }
      const text=installed?this.dataset.abrisIncluded:this.dataset.abrisRegularFee;
      if(this.fee&&this.fee.textContent!==text)this.fee.textContent=text;
      if(this.dataset.abrisInstalled!==(installed?'true':'false'))this.dataset.abrisInstalled=installed?'true':'false';
    }
    parseDate(text) {
      if(!/^\d{4}-\d{2}-\d{2}$/.test(text||''))return null;
      const date=new Date(text+'T12:00:00Z');
      if(!Number.isFinite(date.getTime())||date.toISOString().slice(0,10)!==text)return null;
      return date;
    }
    refreshWindow() {
      if(!this.windowText)return;
      const start=this.parseDate(this.dataset.abrisStart);
      const end=this.parseDate(this.dataset.abrisEnd);
      if(!start||!end||end<start||end.getTime()<Date.now()-86400000)return;
      const locale=this.dataset.abrisLang==='en'?'en-CA':'fr-CA';
      const sameMonth=start.getUTCFullYear()===end.getUTCFullYear()&&start.getUTCMonth()===end.getUTCMonth();
      const year=end.getUTCFullYear()!==new Date().getFullYear();
      const full={month:'long',day:'numeric'};
      if(year)full.year='numeric';
      let text;
      if(locale==='fr-CA'){
        const finish=new Intl.DateTimeFormat(locale,full).format(end);
        const begin=sameMonth?String(start.getUTCDate()):new Intl.DateTimeFormat(locale,full).format(start);
        text='du '+begin+' au '+finish;
      }else{
        const first=new Intl.DateTimeFormat(locale,full).format(start);
        const finish=sameMonth?String(end.getUTCDate()):new Intl.DateTimeFormat(locale,full).format(end);
        text=first+' – '+finish;
      }
      if(this.windowText.textContent!==text)this.windowText.textContent=text;
    }
  }
  customElements.define('abris-delivery-estimate',AbrisDeliveryEstimate);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["abris-delivery-fixed"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('abris-delivery-fixed')) {
  class AbrisDeliveryFixed extends HTMLElement {
    connectedCallback() {
      this.scope=this.closest('.shopify-section')||document;
      this.fee=this.querySelector('[data-abris-delivery-fee]');
      this.windowText=this.querySelector('[data-abris-delivery-window]');
      this.refreshWindow();
      this.queue=()=>{
        if(this.frame)return;
        this.frame=requestAnimationFrame(()=>{
          this.frame=null;
          this.refreshInstallation();
        });
      };
      this.observer=new MutationObserver(records=>{
        if(records.some(record=>!this.contains(record.target)))this.queue();
      });
      this.observer.observe(this.scope,{
        subtree:true,
        childList:true,
        attributes:true,
        attributeFilter:['checked','aria-checked','class','disabled','hidden']
      });
      this.scope.addEventListener('change',this.queue,true);
      this.scope.addEventListener('input',this.queue,true);
      this.scope.addEventListener('click',this.queue,true);
      this.poll=window.setInterval(()=>{
        if(!this.isConnected)return;
        if(!document.hidden)this.queue();
      },450);
      this.refreshInstallation();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.clearInterval(this.poll);
      if(this.frame)cancelAnimationFrame(this.frame);
      this.scope?.removeEventListener('change',this.queue,true);
      this.scope?.removeEventListener('input',this.queue,true);
      this.scope?.removeEventListener('click',this.queue,true);
    }
    refreshInstallation() {
      let installed=this.dataset.abrisForceIncluded==='true';
      const selected=this.scope.querySelectorAll('input.tpo-checkbox-button:checked');
      for(const input of selected) {
        const option=input.closest('.tpo_option-container');
        if(input.disabled||option?.hidden||option?.classList.contains('tpo_hidden'))continue;
        if(option&&getComputedStyle(option).display==='none')continue;
        const label=input.closest('label');
        if(!label)continue;
        const title=label.querySelector('.tpo_option_type_label');
        const name=(title?.textContent||label.textContent||'').replace(/\s+/g,' ').trim();
        if(/installation\s*(?:compl[eè]te|cl[eé]\s*en\s*main)|complete\s*installation|turnkey\s*installation/i.test(name)){
          installed=true;
          break;
        }
      }
      const text=installed?this.dataset.abrisIncluded:this.dataset.abrisRegularFee;
      if(this.fee&&this.fee.textContent!==text)this.fee.textContent=text;
      if(this.dataset.abrisInstalled!==(installed?'true':'false'))this.dataset.abrisInstalled=installed?'true':'false';
    }
    parseDate(text) {
      if(!/^\d{4}-\d{2}-\d{2}$/.test(text||''))return null;
      const date=new Date(text+'T12:00:00Z');
      if(!Number.isFinite(date.getTime())||date.toISOString().slice(0,10)!==text)return null;
      return date;
    }
    refreshWindow() {
      if(!this.windowText)return;
      const start=this.parseDate(this.dataset.abrisStart);
      const end=this.parseDate(this.dataset.abrisEnd);
      const label=this.querySelector('[data-abris-delivery-estimate-label]');
      if(!start||!end||end<start||end.getTime()<Date.now()-86400000) {
        if(label)label.hidden=true;
        this.windowText.textContent=this.dataset.abrisPending||'';
        return;
      }
      if(label)label.hidden=false;
      const locale=this.dataset.abrisLang==='en'?'en-CA':'fr-CA';
      const sameMonth=start.getUTCFullYear()===end.getUTCFullYear()&&start.getUTCMonth()===end.getUTCMonth();
      const year=start.getUTCFullYear()!==end.getUTCFullYear()||end.getUTCFullYear()!==new Date().getFullYear();
      const full={month:'short',day:'numeric',timeZone:'UTC'};
      if(year)full.year='numeric';
      const formatter=new Intl.DateTimeFormat(locale,full);
      let text;
      if(locale==='fr-CA') {
        const day=date=>date.getUTCDate()===1?'1er':String(date.getUTCDate());
        const shortDate=date=>formatter.format(date).replace(/^1(?=\s|$)/,'1er');
        const begin=sameMonth?day(start):shortDate(start);
        const finish=shortDate(end);
        text=begin+' – '+finish;
      }else{
        const begin=formatter.format(start);
        const finish=sameMonth?String(end.getUTCDate()):formatter.format(end);
        text=begin+' – '+finish;
      }
      if(this.windowText.textContent!==text)this.windowText.textContent=text;
    }
  }
  customElements.define('abris-delivery-fixed',AbrisDeliveryFixed);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["abris-review-badge"] && !Shopify.designMode) return;
  try {
    function refreshAbrisReviewCards(modal, reset) {
    const initial = Math.max(1, parseInt(modal.dataset.visibleReviews || '5', 10) || 5);
    const cards = Array.from(modal.querySelectorAll('.abris-review-modal__card'));
    const previous = parseInt(modal.dataset.reviewsShown || String(initial), 10) || initial;
    const shown = reset ? initial : Math.min(cards.length, previous + initial);
    cards.forEach((card, index) => {
      card.hidden = index >= shown;
    });
    modal.dataset.reviewsShown = String(shown);
    const more = modal.querySelector('[data-abris-review-more]');
    if (more) more.hidden = cards.length <= shown;
  }

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const dialog = event.target.closest('.abris-review-modal');
    if (dialog && dialog.open) dialog.dataset.abrisKeyboardDismiss = 'true';
  });

  document.addEventListener('click', function(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const opener = target.closest('[data-abris-review-open]');
    if (opener) {
      const wrapper = opener.closest('.abris-review-badge-wrap');
      const modal = wrapper && wrapper.querySelector('.abris-review-modal');
      if (modal && !modal.open && typeof modal.showModal === 'function') {
        const openedWithKeyboard = event.detail === 0;
        modal.addEventListener('close', function restoreFocus() {
          if (!opener.isConnected) return;
          const closedWithKeyboard = modal.dataset.abrisKeyboardDismiss === 'true';
          delete modal.dataset.abrisKeyboardDismiss;
          if (openedWithKeyboard || closedWithKeyboard) {
            opener.focus({ preventScroll: true });
          } else {
            opener.blur();
            requestAnimationFrame(function clearPointerFocus() {
              if (opener.isConnected) opener.blur();
            });
          }
        }, { once: true });
        modal.showModal();
        refreshAbrisReviewCards(modal, true);
      }
      return;
    }
    const more = target.closest('[data-abris-review-more]');
    if (more) {
      const modal = more.closest('.abris-review-modal');
      if (modal && modal.open) refreshAbrisReviewCards(modal, false);
      return;
    }
    const closeButton = target.closest('[data-abris-review-close]');
    if (closeButton) {
      const modal = closeButton.closest('.abris-review-modal');
      if (modal && modal.open) {
        if (event.detail === 0) modal.dataset.abrisKeyboardDismiss = 'true';
        modal.close();
      }
      return;
    }
    const modal = target.closest('.abris-review-modal');
    if (modal && target === modal && modal.open) {
      const rect = modal.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) modal.close();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["abris-selection-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('abris-selection-summary')) {
    class AbrisSelectionSummary extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.shopify-section');
        this.items = this.querySelector('.abris-summary__items');
        if (!this.scope || !this.items) return;
        this.variants = new Map(JSON.parse(this.querySelector('[data-summary-variants]').textContent).map(variant => [String(variant.id), variant]));
        this.total = this.querySelector('[data-summary-total]');
        this.liveDeliveryRow = this.querySelector('[data-summary-live-delivery]');
        this.liveDeliveryLabel = this.querySelector('[data-summary-live-delivery-label]');
        this.liveDeliveryValue = this.querySelector('[data-summary-live-delivery-value]');
        this.estimatedRow = this.querySelector('[data-summary-estimated-row]');
        this.estimatedValue = this.querySelector('[data-summary-estimated-value]');
        this.legacyDelivery = this.querySelector('[data-summary-legacy-delivery]');
        this.legacyDeliveryNote = this.querySelector('[data-summary-legacy-delivery-note]');
        this.lastRows = null;
        this.stackVariantDetails = this.dataset.stackVariantDetails === 'true';
        this.queueUpdate = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.updateSummary();
          });
        };
        this.onMutation = records => {
          if (records.some(record => !this.contains(record.target))) this.queueUpdate();
        };
        this.observer = new MutationObserver(this.onMutation);
        this.observer.observe(this.scope, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['aria-checked', 'checked', 'value', 'class', 'hidden', 'style', 'disabled']
        });
        this.scope.addEventListener('abris:delivery-change', this.queueUpdate);
        this.scope.addEventListener('change', this.queueUpdate);
        this.scope.addEventListener('input', this.queueUpdate);
        this.scope.addEventListener('click', this.queueUpdate);
        this.poll = setInterval(() => {
          if (!document.hidden) this.queueUpdate();
        }, 250);
        this.queueUpdate();
      }

      disconnectedCallback() {
        clearInterval(this.poll);
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        this.scope?.removeEventListener('abris:delivery-change', this.queueUpdate);
        this.scope?.removeEventListener('change', this.queueUpdate);
        this.scope?.removeEventListener('input', this.queueUpdate);
        this.scope?.removeEventListener('click', this.queueUpdate);
      }

      readSelection() {
        const form = this.scope.querySelector('product-form-component form[action*="/cart/add"]');
        const variantId = form?.querySelector('[name="id"]')?.value;
        const variant = this.variants.get(String(variantId ?? this.dataset.initialVariant));
        if (!variant) return null;
        const name = variant.label === 'Default Title' ? this.dataset.productTitle : `${this.dataset.productTitle} · ${variant.label}`;
        const rows = [[name, this.formatMoney(variant.price)]];
        let subtotal = variant.price;
        const selected = this.scope.querySelectorAll('input.tpo-checkbox-button:checked');
        for (const input of selected) {
          const container = input.closest('.tpo_option-container');
          if (input.disabled || container?.hidden || container?.classList.contains('tpo_hidden')) continue;
          if (container && getComputedStyle(container).display === 'none') continue;
          const label = input.closest('label')?.querySelector('.tpo_option_type_label');
          // Easify's native title may be wrapped with its tooltip in the premium
          // configurator. Read only its direct text nodes so tooltip copy and
          // additional price never become part of the selected option's name.
          const nameContainer = label?.querySelector(':scope > .abris-premium-title-with-tooltip') || label;
          const name = nameContainer ? Array.from(nameContainer.childNodes)
            .filter(node => node.nodeType === Node.TEXT_NODE)
            .map(node => node.textContent).join(' ').replace(/\s+/g, ' ').trim() : '';
          const price = label?.querySelector('.tpo_additional-price')?.textContent
            .trim().replace(/^\(\s*/, '').replace(/\s*\)$/, '');
          if (!name || !price) return null;
          const cents = this.readMoney(price);
          if (cents === null) return null;
          subtotal += cents;
          rows.push([name, this.formatMoney(cents)]);
        }
        const delivery = this.scope.querySelector('abris-delivery-date');
        const preference = delivery?.preference?.();
        if (preference) rows.push([delivery.dataset.summaryLabel, preference]);
        const quantityInput = form?.elements.namedItem('quantity');
        const quantity = Math.max(1, Number(quantityInput?.value) || 1);
        return { rows, subtotal: subtotal * quantity };

      }

      // The delivery block is the presentation source of truth. Shopify calculates
      // and charges the actual shipping rate at checkout; do NOT add it to the
      // product/options subtotal or introduce a second cart charge.
      readLiveDelivery() {
        const block = this.scope.querySelector('abris-delivery-fixed');
        const label = block?.querySelector('.abris-delivery-fixed__label')?.textContent?.trim();
        const value = block?.querySelector('[data-abris-delivery-fee]')?.textContent?.trim();
        if (!label || !value) return null;
        return {
          label,
          value,
          included: block.dataset.abrisInstalled === 'true'
        };
      }

      syncLiveDelivery() {
        const shipping = this.readLiveDelivery();
        if (this.liveDeliveryRow) {
          this.liveDeliveryRow.hidden = !shipping;
          if (shipping) {
            if (this.liveDeliveryLabel.textContent !== shipping.label) this.liveDeliveryLabel.textContent = shipping.label;
            if (this.liveDeliveryValue.textContent !== shipping.value) this.liveDeliveryValue.textContent = shipping.value;
            this.liveDeliveryRow.classList.toggle('abris-summary__shipping-row--included', shipping.included);
          }
        }
        // Older templates may have a merchant-configured static delivery row.
        // Suppress it only when the live delivery block is available, avoiding
        // duplicate and potentially contradictory shipping information.
        if (this.legacyDelivery) this.legacyDelivery.hidden = !!shipping;
        if (this.legacyDeliveryNote) this.legacyDeliveryNote.hidden = !!shipping;
        return shipping;
      }

      readMoney(value) {
        let number = value.replace(/[^0-9.,−-]/g, '').replace('−', '-');
        if (!/\d/.test(number)) return null;
        const decimal = number.match(/[.,](\d{1,2})$/);
        if (decimal) {
          const position = number.length - decimal[0].length;
          number = number.slice(0, position).replace(/[.,]/g, '') + '.' + decimal[1];
        } else number = number.replace(/[.,]/g, '');
        const cents = Math.round(Number(number) * 100);
        return Number.isFinite(cents) ? cents : null;
      }

      formatMoney(cents) {
        const language = (document.documentElement.lang || 'fr').toLowerCase().startsWith('fr') ? 'fr-CA' : 'en-CA';
        return new Intl.NumberFormat(language, {
          style: 'currency',
          currency: 'CAD',
          minimumFractionDigits: Math.abs(cents) % 100 === 0 ? 0 : 2,
          maximumFractionDigits: 2
        }).format(cents / 100);
      }

      updateSummary() {
        const selection = this.readSelection();
        if (!selection) {
          this.hidden = true;
          this.lastRows = null;
          return;
        }
        const { rows, subtotal } = selection;
        const shipping = this.syncLiveDelivery();
        // Shopify determines actual shipping at checkout. This is display only.
        // Do not alter the product/options subtotal or the cart shipping charge.
        const deliveryCents = !shipping ? null : shipping.included ? 0 : this.readMoney(shipping.value);
        const estimatedCents = deliveryCents === null ? null : subtotal + deliveryCents;
        if (this.estimatedRow) this.estimatedRow.hidden = estimatedCents === null;
        if (this.estimatedValue && estimatedCents !== null) {
          const formatted = this.formatMoney(estimatedCents);
          if (this.estimatedValue.textContent !== formatted) this.estimatedValue.textContent = formatted;
        }
        const signature = JSON.stringify(selection);
        if (signature !== this.lastRows) {
          const fragment = document.createDocumentFragment();
          rows.forEach(([name, price], rowIndex) => {
            const row = document.createElement('div');
            row.className = 'abris-summary__row';
            const term = document.createElement('dt');
            const value = document.createElement('dd');
            if (this.stackVariantDetails && rowIndex === 0 && name.includes(' · ')) {
              const [productName, ...variantParts] = name.split(' · ');
              const primary = document.createElement('span');
              const detail = document.createElement('span');
              primary.textContent = productName;
              detail.className = 'abris-summary__variant-detail';
              detail.textContent = variantParts.join(' · ');
              term.append(primary, detail);
            } else {
              term.textContent = name;
            }
            value.textContent = price;
            row.append(term, value);
            fragment.append(row);
          });
          this.items.replaceChildren(fragment);
          this.total.textContent = this.formatMoney(subtotal);
          this.lastRows = signature;
        }
        this.hidden = false;
      }
    }
    customElements.define('abris-selection-summary', AbrisSelectionSummary);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["starting-price"] && !Shopify.designMode) return;
  try {
    (() => {
    const startingPriceSelector =
      '.starting-price[data-hide-label-after-selection="true"]';

    const normalizeVariantId = (value) => {
      if (value == null) return '';

      const normalized = String(value).trim();

      if (!normalized) return '';

      return normalized.split('/').pop() || '';
    };

    const getScope = (element) => {
      if (!(element instanceof Element)) return null;

      return element.closest('.shopify-section, dialog');
    };

    const getStartingPrices = (scope) => {
      if (!scope) return [];

      return Array.from(
        scope.querySelectorAll(startingPriceSelector)
      );
    };

    const getPriceMap = (startingPrice) => {
      const script = startingPrice.querySelector(
        '[data-starting-price-variant-prices]'
      );

      if (!script) return {};

      try {
        return JSON.parse(script.textContent || '{}');
      } catch {
        return {};
      }
    };

    const hideLabel = (startingPrice) => {
      startingPrice.classList.add(
        'starting-price--label-hidden'
      );
    };

    const setVariantPrice = (
      startingPrice,
      variantId
    ) => {
      const id = normalizeVariantId(variantId);

      if (!id) return false;

      const priceMap =
        getPriceMap(startingPrice);

      const price = priceMap[id];

      if (!price) return false;

      const amount =
        startingPrice.querySelector(
          '[ref="priceContainer"]'
        );

      if (!amount) return false;

      amount.innerHTML = price;

      return true;
    };

    const syncStartingPrice = (
      scope,
      variantId = ''
    ) => {
      const id =
        normalizeVariantId(variantId);

      getStartingPrices(scope).forEach(
        (startingPrice) => {
          hideLabel(startingPrice);

          if (id) {
            setVariantPrice(
              startingPrice,
              id
            );
          }
        }
      );
    };

    document.addEventListener(
      'shopify:product:select',
      (event) => {
        if (
          !(event.target instanceof Element)
        ) {
          return;
        }

        const scope =
          getScope(event.target);

        if (!scope) return;

        const immediateVariantId =
          normalizeVariantId(
            event.detail?.variantId || ''
          );

        syncStartingPrice(
          scope,
          immediateVariantId
        );

        if (
          !event.promise ||
          typeof event.promise.then !== 'function'
        ) {
          return;
        }

        event.promise
          .then(({ variant, detail }) => {
            const resolvedVariantId =
              normalizeVariantId(
                detail?.resource?.id ||
                variant?.id ||
                ''
              );

            if (!resolvedVariantId) {
              return;
            }

            syncStartingPrice(
              scope,
              resolvedVariantId
            );
          })
          .catch(() => {});
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
